<template>
  <div>
    <!-- 公司/机构人员信息true -->
    <div style="width:100%;  margin:auto " v-if="isReloadData">
      <el-row>
        <!-- <p style="text-align: center; margin-right: 3%; ">
          <span class="systemFont1">{{ $t("p0201.companyUserInfo") }}</span>
        </p> -->
        <!-- 添加已注册用户true -->
        <div style="border: 1px solid #CCC; width:97%;margin:auto;">
          <p style="text-align: left;">
            <span class="systemFont1" style="margin-left:20px;">{{
              $t("p0201companyUserInfo.addRegisteredUser")
            }}</span>
          </p>
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-position="right"
            label-width="100px"
            class="systemFont2"
          >
            <!-- 搜索 -->
            <el-row style="">
              <el-col :span="24">
                <el-col
                  :span="8"
                  style="
            display: block;
            text-align: right;
            line-height: 40px;
            padding: 0 20px;
          "
                >
                  <!-- 个人用户 -->
                  <span class="systemFont1">{{
                    $t("p0201companyUserInfo.personalUser")
                  }}</span>
                </el-col>
                <el-col :span="8">
                  <el-col :span="24"
                    ><el-input
                      v-model="queryForm.queryCriteria"
                      :placeholder="
                        $t('p0201companyUserInfo.searchPlaceholder')
                      "
                    ></el-input
                  ></el-col>
                </el-col>
                <el-col
                  :span="8"
                  style="display: block; text-align: left; padding: 0 20px"
                >
                  <img
                    src="../../assets/p0322Query.svg"
                    width="36px"
                    height="36px"
                    style="cursor: pointer"
                    @click="getUserDetail(true)"
                  />
                </el-col>
              </el-col>
            </el-row>
          </el-form>
          <el-row><br /></el-row>
          <el-row>
            <el-col>
              <el-table
                :data="companyUserDetail"
                ref="companyUserDetailRef"
                v-loading="pageLoading"
                tooltip-effect="dark"
                style="width:90%;margin:auto"
                @selection-change="handleSelectionChange"
              >
                <el-table-column
                  type="selection"
                  width="55"
                  :selectable="selectable"
                ></el-table-column>
                <!-- 头像 -->
                <el-table-column
                  :label="$t('p0201companyUserInfo.headPortrait')"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-avatar
                      :src="viewHeadPortrait(scope.row.headPortrait)"
                      :key="scope.row.headPortrait"
                      :size="30"
                    ></el-avatar>
                  </template>
                </el-table-column>
                <!-- 姓名-->
                <el-table-column
                  prop="name"
                  :label="$t('p0201companyUserInfo.userName')"
                  align="center"
                ></el-table-column>
                <!-- 英文姓名 -->
                <el-table-column
                  prop="englishName"
                  :label="$t('p0201companyUserInfo.englishName')"
                  align="center"
                ></el-table-column>
                <!-- 昵称 -->
                <el-table-column
                  prop="nickName"
                  :label="$t('p0201companyUserInfo.nickname')"
                  align="center"
                ></el-table-column>
                <!-- 注册日期 -->
                <el-table-column
                  prop="createTime"
                  :label="$t('p0201companyUserInfo.registerDate')"
                  align="center"
                ></el-table-column>
                <!-- 手机 -->
                <el-table-column
                  prop="phoneNo"
                  :label="$t('p0201companyUserInfo.phoneNo')"
                  align="center"
                ></el-table-column>
                <!-- 邮箱 -->
                <!-- <el-table-column
                    prop="email"
                    :label="$t('p0201companyUserInfo.email')"
                    align="center"
                  ></el-table-column> -->
              </el-table>
            </el-col>
          </el-row>
          <!-- 分页 -->
          <el-row style="text-align: right; margin: 20px">
            <el-col :span="24">
              <div class="block">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page.sync="currentPage"
                  :page-sizes="[6, 8, 10]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next"
                  :total="total"
                >
                </el-pagination>
              </div>
            </el-col>
          </el-row>
          <el-row class="foot-container">
            <span>
              <!-- 添加  -->
              <el-button
                type="p0332Button"
                size="medium"
                @click="registedUserToCom"
                >{{ $t("p0201companyUserInfo.add") }}</el-button
              >
              <!-- 返回  -->
              <el-button type="return" size="medium" @click="closeDialog">{{
                $t("common.back")
              }}</el-button>
            </span>
          </el-row>
          <el-row><br /><br /></el-row>
        </div>
        <p></p>
        <!-- 添加未注册用户true -->
        <div
          style="border: 1px solid #CCC; height:350px; width:97%;margin:auto;"
        >
          <p style="text-align: left;">
            <span class="systemFont1" style="margin-left:20px;">{{
              $t("p0201companyUserInfo.addNoRegisterUser")
            }}</span>
          </p>
          <el-col :span="24">
            <el-form
              :rules="rules"
              ref="noAddForm"
              class="systemFont2 systemForm1"
              :model="noAddForm"
              label-position="right"
              label-width="60px"
              hide-required-asterisk
            >
              <el-row>
                <p></p>
              </el-row>
              <el-row>
                <el-col :span="9" :offset="1">
                  <!-- 姓名 -->
                  <el-form-item label-width="0px">
                    <el-col :span="12">
                      <!-- 姓 -->
                      <el-form-item
                        :label="$t('p0211.lastName')"
                        prop="lastName"
                      >
                        <el-input
                          v-model="noAddForm.lastName"
                          size="reportContentInput"
                          maxlength="125"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <!-- 名 -->
                      <el-form-item
                        :label="$t('p0211.firstName')"
                        prop="firstName"
                      >
                        <el-input
                          v-model="noAddForm.firstName"
                          size="reportContentInput"
                          maxlength="125"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-form-item>
                  <!-- 手机 -->
                  <el-form-item :label="$t('p0201companyUserInfo.phoneNo')">
                    <el-col :span="8">
                      <el-form-item>
                        <el-select
                          size="systemSelect3"
                          v-model="noAddForm.phoneArea"
                        >
                          <el-option
                            v-for="item in areaList"
                            :key="item.phoneAreaId"
                            :label="item.dialCode"
                            :value="item.dialCode"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="15" :offset="1">
                      <el-form-item prop="phone">
                        <el-input
                          size="reportContentInput"
                          maxlength="125"
                          v-model="noAddForm.phone"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-form-item>
                  <!-- 职位 -->
                  <el-form-item
                    :label="$t('p0201companyUserInfo.position')"
                    prop="position"
                  >
                    <el-input
                      v-model="noAddForm.position"
                      size="reportContentInput"
                      maxlength="125"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="9" :offset="4">
                  <!-- 邮箱 -->
                  <el-form-item
                    :label="$t('p0201companyUserInfo.email')"
                    prop="email"
                  >
                    <el-input
                      v-model="noAddForm.email"
                      size="reportContentInput"
                      maxlength="64"
                    >
                    </el-input>
                  </el-form-item>

                  <!-- 部门 -->
                  <el-form-item
                    :label="$t('p0201companyUserInfo.department')"
                    prop="department"
                  >
                    <el-input
                      v-model="noAddForm.department"
                      size="reportContentInput"
                      maxlength="64"
                    >
                    </el-input>
                  </el-form-item>
                  <!-- 备注 -->
                  <el-form-item :label="$t('p0201.remarks')" prop="remarks">
                    <el-input
                      v-model="noAddForm.remarks"
                      size="reportContentInput"
                      maxlength="64"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="foot-container">
                <span>
                  <!-- 添加  -->
                  <el-button
                    type="p0332Button"
                    size="medium"
                    @click="addNoRegisterUser"
                    >{{ $t("p0201companyUserInfo.add") }}</el-button
                  >
                  <!-- 返回  -->
                  <el-button type="return" size="medium" @click="closeDialog">{{
                    $t("common.back")
                  }}</el-button>
                </span>
              </el-row>
            </el-form>
          </el-col>
        </div>
        <p></p>
      </el-row>
    </div>
    <p>&nbsp;</p>
  </div>
</template>

<script>
import qs from "qs";
import uploadFile from "../../components/Common/UploadAttachment.vue";
export default {
  props: {
    getUser: {
      type: Function,
      default: null
    },
    closeDialog: {
      type: Function,
      default: null
    }
  },
  components: {
    uploadFile
  },
  data() {
    //验证手机号的正则表达式
    // let reg = /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[3-8]{1})|(18[0-9]{1})|(19[0-9]{1})|(14[5-7]{1}))+\d{8})$/;
    //验证方法
    var validatorPhone = (phone, value, callback) => {
      if (value === "") {
        callback();
      } else if (!reg.test(value)) {
        return callback(new Error(this.$t("p0201.checkTel")));
      }
      callback();
    };
    //电话邮箱格式
    var validateEmAndPho = (rule, value, callback) => {
      if (!this.noAddForm.email && !this.noAddForm.phone) {
        return callback(
          new Error(this.$t("p0201companyUserInfo.validateEmAndPho"))
        );
      } else if (this.noAddForm.email) {
        this.$refs.noAddForm.clearValidate("phone");
        callback();
      } else if (this.noAddForm.phone) {
        this.$refs.noAddForm.clearValidate("email");
        callback();
      }
      callback();
    };
    // 验证规则 - 姓
    const checkLastName = (rule, value, callback) => {
      const checkNotNull = this.checkNotNull(this.noAddForm.firstName);
      const isChinese = /^[\u4e00-\u9fa5]+$/.test(value); // 判断是否为中文
      const isEnglish = /^[a-zA-Z]+$/.test(value); // 判断是否为英文
      if ((isChinese && !isEnglish) || (isEnglish && !isChinese)) {
        const isChineseFirstName = /^[\u4e00-\u9fa5]+$/.test(
          this.noAddForm.firstName
        ); // 获取姓是否为中文
        const isEnglishFirstName = /^[a-zA-Z]+$/.test(this.noAddForm.firstName); // 获取姓是否为英文
        if (checkNotNull && isChineseFirstName) {
          // 姓是中文
          if (value && !/^[\u4e00-\u9fa5]+$/.test(value)) {
            // 名不是中文
            callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
          } else {
            this.$refs.noAddForm.clearValidate("firstName");
            callback(); // 校验通过
          }
        } else if (checkNotNull && isEnglishFirstName) {
          // 姓是英文
          if (value && !/^[a-zA-Z]+$/.test(value)) {
            // 名不是英文
            callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
          } else {
            this.$refs.noAddForm.clearValidate("firstName");
            callback(); // 校验通过
          }
        } else if (checkNotNull) {
          // 姓不是中文也不是英文
          callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
        }
      } else {
        callback(new Error(this.$t("p0211.msg3"))); // 校验不通过，抛出错误信息
      }
    };

    // 验证规则 - 名
    const checkFirstName = (rule, value, callback) => {
      const checkNotNull = this.checkNotNull(this.noAddForm.lastName);
      const isChineseLastName = /^[\u4e00-\u9fa5]+$/.test(
        this.noAddForm.lastName
      ); // 获取姓是否为中文
      const isEnglishLastName = /^[a-zA-Z]+$/.test(this.noAddForm.lastName); // 获取姓是否为英文
      const isChinese = /^[\u4e00-\u9fa5]+$/.test(value); // 判断是否为中文
      const isEnglish = /^[a-zA-Z]+$/.test(value); // 判断是否为英文
      if ((isChinese && !isEnglish) || (isEnglish && !isChinese)) {
        // 判断语言是否一致
        if (checkNotNull && isChineseLastName) {
          // 姓是中文
          if (value && !/^[\u4e00-\u9fa5]+$/.test(value)) {
            // 名不是中文
            callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
          } else {
            this.$refs.noAddForm.clearValidate("lastName");
            callback(); // 校验通过
          }
        } else if (checkNotNull && isEnglishLastName) {
          // 姓是英文
          if (value && !/^[a-zA-Z]+$/.test(value)) {
            // 名不是英文
            callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
          } else {
            this.$refs.noAddForm.clearValidate("lastName");
            callback(); // 校验通过
          }
        } else if (checkNotNull) {
          // 姓不是中文也不是英文
          callback(new Error(this.$t("p0211.msg2"))); // 校验不通过，抛出错误信息
        }
      } else {
        callback(new Error(this.$t("p0211.msg3"))); // 校验不通过，抛出错误信息
      }
    };
    let p0202 = JSON.parse(sessionStorage.getItem("p0202"));
    return {
      // 默认头像图片
      defaultImg: require("../../assets/headPortrait.png"),
      mCompanyId: p0202.mCompanyId,
      // 查询条件
      queryForm: {
        queryCriteria: ""
      },
      // 区号列表
      areaList: [],
      //第二个div
      isReloadData: true,
      // 公司/机构人员信息一览
      companyUserView: [],
      // 后台用户信息
      companyUserDetail: [],
      //多选状态
      // selectable: true,
      //添加未注册用户
      noAddForm: {
        lastName: "",
        firstName: "",
        department: "",
        position: "",
        remarks: "",
        email: "",
        phone: "",
        phoneArea: "+86"
      },
      // btnDisabled: localStorage.getItem("newRegCompanyId"),
      //按钮状态
      tipDisabled: true,
      btnDisabled: false,
      countryList: [],
      // 页面载入状态
      pageLoading: false,
      viewFlag: true,
      //新增表单
      formData: {
        companyName: "",
        province: "",
        city: "",
        county: "",
        companyTaxNumber: "",
        areaCode: "+86",
        country: "中国"
      },
      //公司信息显示状态
      basicShow: true,
      //行业list
      industryList: [],
      // 上传按钮控件是否显示按钮（重新加载用）
      uploadFileReloadFlag: true,
      // 上传按钮显示标志
      uploadBtnDisplayFlag: true,
      // 位置关联Code
      locationCode: "",
      // 公司数据
      companyData: [],
      form: {},
      // 当前页
      currentPage: 1,
      // 每页件数
      pageSize: 6,
      total: 0,
      total1: 0,
      //选择的用户
      multipleSelection: [],
      //用户id列表
      userIds: [],
      //禁用列表:
      indexList: [],
      // 区
      counties: [],
      //上传文件列表
      uploadFileList: [],
      // 检索条件保持变量
      tmpQueryStr: "",
      // 公司注册校验
      checkCompanyName: [
        {
          required: true,
          message: this.$t("p0201.enterCompanyName"),
          trigger: "blur"
        }
      ],
      checkTaxNumber: [
        {
          required: true,
          message: this.$t("p0201.enterTaxNumber"),
          trigger: "blur"
        }
      ],
      checkPhone: [
        {
          required: false,
          trigger: "blur",
          validator: (r, v, b) => {
            v && !/^(?:(?:\+|00)86)?1\d{10}$/.test(v)
              ? b(this.$t("p0201.checkTel"))
              : b();
          }
        }
      ],
      // 未注册用户校验规则
      rules: {
        lastName: [
          {
            required: true,
            message: this.$t("p0211.checkLastName"),
            trigger: "blur"
          },
          { required: false, validator: checkLastName, trigger: "blur" }
        ],
        firstName: [
          {
            required: true,
            message: this.$t("p0211.checkFirstName"),
            trigger: "blur"
          },
          { required: false, validator: checkFirstName, trigger: "blur" }
        ],
        email: [
          {
            required: true,
            validator: validateEmAndPho,
            trigger: "blur"
          },
          {
            pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
            message: this.$t("p0211.correctEmail"),
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            validator: validateEmAndPho,
            trigger: "blur"
          },
          {
            pattern: /(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            message: this.$t("p0201.checkTel"),
            trigger: "blur"
          }
        ]
      },
      index1: 0,
      //企查查弹框
      autoVisabled: false
    };
  },
  mounted() {
    this.getArea();
    this.getUserDetail(false);
  },
  methods: {
    checkNotNull(str) {
      if (str === null || str === "" || typeof str === "undefined") {
        return false;
      } else {
        return true;
      }
    },
    init() {
      let url = "/api/companyOrganizationCustomers/peopleAdded";
      this.$http
        .post(
          url,
          qs.stringify({
            mCompanyId: this.mCompanyId
          })
        )
        .then(response => {
          if (response.data.code === 200) {
            this.companyUserView = response.data.data;
            this.$refs.companyUserDetailRef.clearSelection();
            if (typeof this.$refs.noAddForm !== "undefined") {
              this.$refs.noAddForm.clearValidate();
              this.noAddForm = {
                lastName: "",
                firstName: "",
                department: "",
                position: "",
                remarks: "",
                email: "",
                phone: "",
                phoneArea: "+86"
              };
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    selectable(row, index) {
      for (let i = 0; i < this.companyUserView.length; i++) {
        if (row.userId == this.companyUserView[i].userId) {
          return false;
        }
      }
      return true;
      // 函数必须有返回值且是布尔值
      // 页面刷新后该函数会执行 N 次进行判断(N 为表格行数)
      // 如果没有返回值则默认返回false(全部无法选中)
    },
    //获取区号
    getArea() {
      let url = "/api/CompanyCusAdd/getPhoneArea";
      // 访问对应后端的api获取画面数据
      this.$http
        .post(url, qs.stringify({}))
        .then(response => {
          if (response.data.code === 200) {
            this.areaList = response.data.data;
            // console.log(this.areaList);
            // this.yearsList = response.data.data;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message({
            message: "查询失败！",
            type: "error"
          });
        });
    },
    //选择的用户
    handleSelectionChange(val) {
      // console.log('select',val);
      // this.indexList = val.map(item => {
      // return this.companyUserDetail.indexOf(item);
      // });
      // console.log(indexList)
      // this.selectable(1);

      this.multipleSelection = val;
    },
    //添加未注册用户到公司
    addNoRegisterUser() {
      this.$refs.noAddForm.validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            background: "rgba(255,255,255,0.8)",
            target: document.querySelector(".roll-dialog")
          });
          console.log(this.noAddForm);

          let url;
          let params;
          url = "/api/CompanyCusAdd/addNoRegisteredUser";
          params = {
            lastName: this.noAddForm.lastName,
            firstName: this.noAddForm.firstName,
            department: this.noAddForm.department,
            duties: this.noAddForm.position,
            phoneArea: this.noAddForm.phoneArea,
            remarks: this.noAddForm.remarks,
            phone: this.noAddForm.phone,
            email: this.noAddForm.email,
            companyId: this.mCompanyId,
            loginUid: localStorage.getItem("userId")
          };
          // console.log(params);
          this.$http
            .post(url, qs.stringify(params))
            .then(response => {
              loading.close();
              this.response = JSON.stringify(response.data);
              if (response.data.code === 200) {
                this.$message.success(this.$t("p0323.addedSuccessfully"));
                this.companyUserView = response.data.data;
                this.noAddForm = {};
                this.noAddForm.phoneArea = "+86";
                this.getUser();
              } else {
                this.$message.error(response.data.message);
              }
            })
            .catch(err => {
              loading.close();
              console.log(err);
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
        }
      });
    },
    //添加已注册用户到公司
    registedUserToCom() {
      console.log(
        "🚀 ~ file: P0206.vue ~ line 987 ~ registedUserToCom ~ this.mCompanyId",
        this.mCompanyId
      );
      console.log(this.multipleSelection);
      this.userIds = this.multipleSelection.map(item => {
        return item.userId;
      });
      console.log(this.userIds);
      let url = "/api/CompanyCusAdd/addRegisteredUser";
      let params = {
        companyId: this.mCompanyId,
        userIds: this.userIds,
        loginUid: localStorage.getItem("userId")
      };
      // console.log(params);
      this.$http
        .post(url, qs.stringify(params))
        .then(response => {
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            this.$message.success("添加成功!");
            // console.log(response.data.data);
            let dataList = response.data.data;
            this.companyUserView = dataList;
            this.getUser();
            // let { userId } = dataList;
            // console.log(userId);
            // this.indexList[userId]
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 头像图片显示
    viewHeadPortrait(imgCodeStr) {
      return imgCodeStr == null
        ? this.defaultImg
        : "data:image/png;base64," + imgCodeStr;
    },
    // 改变上传文件的状态
    changeUploadFileStatus() {
      // console.log(this.uploadFile.uploadBtnDisplayFlag) //= !this.uploadFile.uploadBtnDisplayFlag;
      this.uploadBtnDisplayFlag = !this.uploadBtnDisplayFlag;
      this.reloadUploadFile();
    },

    // 重新加载上传附件控件
    async reloadUploadFile() {
      this.uploadFileReloadFlag = false;
      await this.$nextTick();
      this.uploadFileReloadFlag = true;
    },
    initFileUpload() {
      let url = "/api/CompanyCusAdd/initFileUpload";
      // 访问对应的后端的api获取登录信息
      this.$http.post(url).then(response => {
        console.log(response.data.data);
        this.locationCode = response.data.data;
        // sessionStorage.setItem("filePathId",response.data.data)
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      //判断更改页码是否需要查询
      if (
        this.companyUserDetail == undefined ||
        this.companyUserDetail.length <= 0
      ) {
        return;
      }
      this.getUserDetail(false);
      console.log(`每页 ${val} 条`);
    },
    // 公司机构用户一览检索
    getUserDetail(val) {
      this.pageLoading = true;
      if (val) {
        this.currentPage = 1;
        this.total = 0;
        this.tmpQueryStr = this.queryForm.queryCriteria;
      }
      // 换页时，检索条件还原
      this.queryForm.queryCriteria = this.tmpQueryStr;
      let url = "/api/CompanyCusAdd/queryComUserInfo";
      this.$http
        .post(
          url,
          qs.stringify({
            queryCriteria: this.tmpQueryStr,
            currentSize: (this.currentPage - 1) * this.pageSize,
            pageSize: this.pageSize,
            total: this.total
          })
        )
        .then(response => {
          this.pageLoading = false;
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            this.companyUserDetail = response.data.data;
            //判断是否初始化
            if (this.currentPage == 1) {
              this.companyUserDetail = response.data.data;
              this.total = this.companyUserDetail[0].total;
            } else {
              this.companyUserDetail = response.data.data;
            }
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.pageLoading = false;
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getUserDetail(false);
      console.log(`当前页: ${val}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.plusAndMinus {
  text-align: left;
}
// 头像
.hdPortraitCss {
  display: block;
  padding-left: 10px;
}
.textAreaCss {
  margin-top: 9px;
}
.foot-container {
  margin-top: 2%;
  text-align: center;
}
>>> .inputWidth1 {
  width: 100%;
}
>>> .buttonWidth {
  width: 100%;
  min-width: 60px;
}
>>> .el-form-item__label {
  font-size: 14px;
  font-weight: bold;
  color: #333333;
}
#el-form-item__content11 >>> .el-form-item__content {
  position: absolute;
}
#personalUserLabel >>> .el-form-item__label {
  font-size: 16px;
}
// 表格样式
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
>>> .el-button--p0332Button {
  width: 100px;
  height: 30px;
}
>>> .el-button--return {
  width: 100px;
  height: 30px;
}
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}
>>> .el-table .cell {
  line-height: 30px;
  height: 30px;
}
>>> .el-table .el-table__cell {
  padding: 8.5px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/CustomerInfoBase/P0206.vue